import { z } from "zod";

/** Represents the enum public.notification_status */
type NotificationStatus = "sent" | "pending" | "failed";

export default NotificationStatus;

/** Zod schema for notification_status */
export const notificationStatus = z.enum(["sent", "pending", "failed"]);
